module.exports = __webpack_public_path__ + "static/img/logo.a4b4b47b.svg";